module.exports = __webpack_public_path__ + "static/media/Ramen.ad5fa1f9.svg";